<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script>
export default {
    name: 'fade-transition',
    props: {
        /**
         * Whether the component should be a `transition-group` component.
         */
        group: Boolean
    },
}
</script>

<template>
    <transition-group v-if="group"
        v-bind="$attrs"
        enter-active-class="transition-fade--in"
        leave-active-class="transition-fade--out"
        name="transition-fade"
    >
        <slot></slot>
    </transition-group>
    <transition v-else
        v-bind="$attrs"
        enter-active-class="transition-fade--in"
        leave-active-class="transition-fade--out"
        name="transition-fade"
    >
        <slot></slot>
    </transition>
</template>

<style lang="scss">

@keyframes transition-fade--in {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes transition-fade--out {
    from { opacity: 1; }
    to { opacity: 0; }
}

.transition-fade--in {
    animation-name: transition-fade--in;
    animation-duration: var(--duration-fade-in);
    animation-duration: 1s;
}

.transition-fade--out {
    animation-name: transition-fade--out;
    animation-duration: var(--duration-fade-out);
}

.transition-fade-move {
    transition: transform var(--duration-default) var(--easing-default);
}
</style>
